const LINE_OPTIONS_SIZES = {
  large: 'large',
  medium: 'medium',
  small: 'small',
}

const LINE_OPTIONS_COLORS = {
  default: 'default',
  error: 'error',
}

export { LINE_OPTIONS_SIZES, LINE_OPTIONS_COLORS }
